/* eslint-disable camelcase */
import React from 'react';
import { dateFormat } from 'enums';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var paymentsReferenceColumns = [{
  name: 'Главница',
  render: function render(_ref) {
    var principal = _ref.principal,
        currency = _ref.currency;
    return ___EmotionJSX("span", {
      "data-value": "principal"
    }, principal, " ", currency);
  }
}, {
  name: 'Опростени такси',
  render: function render(_ref2) {
    var dropped_fees = _ref2.dropped_fees,
        currency = _ref2.currency;
    return ___EmotionJSX("span", {
      "data-value": "dropped_fees"
    }, dropped_fees, " ", currency);
  }
}, {
  name: 'Допълнително начислени такси',
  render: function render(_ref3) {
    var additional_fees = _ref3.additional_fees,
        currency = _ref3.currency;
    return ___EmotionJSX("span", {
      "data-value": "additional_fees"
    }, additional_fees, " ", currency);
  }
}, {
  name: 'Лихви',
  render: function render(_ref4) {
    var interests = _ref4.interests,
        currency = _ref4.currency;
    return ___EmotionJSX("span", {
      "data-value": "interests"
    }, interests, " ", currency);
  }
}, {
  name: 'Наказателни лихви',
  render: function render(_ref5) {
    var penalties = _ref5.penalties,
        currency = _ref5.currency;
    return ___EmotionJSX("span", {
      "data-value": "penalties"
    }, penalties, " ", currency);
  }
}, {
  name: 'Общо лихви',
  render: function render(_ref6) {
    var total_interests = _ref6.total_interests,
        currency = _ref6.currency;
    return ___EmotionJSX("span", {
      "data-value": "total_interests"
    }, total_interests, " ", currency);
  }
}, {
  name: 'Обща сума на плащането',
  render: function render(_ref7) {
    var payment_amount = _ref7.payment_amount,
        currency = _ref7.currency;
    return ___EmotionJSX("span", {
      "data-value": "payment_amount"
    }, payment_amount, " ", currency);
  }
}, {
  name: 'Дата на плащане',
  value: 'date',
  dateTimeFormat: dateFormat
}, {
  name: 'Кредит номер',
  value: 'credit_number',
  width: '110px'
}];